module.exports = __webpack_public_path__ + "assets/img/intro-normal-1.8a8f5ed1.jpg";